module.exports = __webpack_public_path__ + "src/img/whiteArrow.b7a1abe2.svg";